import { Box } from "@mui/material";

import { financialsRowKinds } from "../types";
import { resolveTotalsBlockName } from "../../totalsBlockName";

import { CoverageHeaderRow } from "./CoverageGroupRowRenderer";
import { TotalsBlockMenu } from "./TotalsBlockMenu";

import type { FinancialsGridContext, FinancialsRow } from "../types";
import type { ICellRendererParams } from "ag-grid-community";

const TotalsHeaderRow = ({
  row,
  context,
}: {
  row: FinancialsRow | undefined;
  context: FinancialsGridContext;
}): React.JSX.Element => {
  const blockId = row?.blockId ?? "default";
  const label = resolveTotalsBlockName(context.blockById.get(blockId));

  return (
    <Box
      data-testid="totals-header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: "100%",
        width: "100%",
        px: 1,
        fontWeight: 500,
      }}
    >
      {label}
      <TotalsBlockMenu blockId={blockId} context={context} />
    </Box>
  );
};

export const FullWidthRowRenderer = ({
  data,
  context,
}: ICellRendererParams<FinancialsRow>): React.JSX.Element => {
  if (data?.kind === financialsRowKinds.COVERAGE_HEADER) {
    return (
      <CoverageHeaderRow
        row={data}
        context={context as FinancialsGridContext}
      />
    );
  }

  return (
    <TotalsHeaderRow row={data} context={context as FinancialsGridContext} />
  );
};
